import { skipToken, useQuery } from "@tanstack/react-query";

import instance from "@/lib/axios";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import type { PaginatedResponse } from "@/types/api-response";
import type {
  FetchNotificationsParams,
  Notification,
} from "@/types/notification";

import { notificationKeys } from "./keys";

async function fetchNotifications(
  orgSlug: string,
  params?: FetchNotificationsParams,
): Promise<PaginatedResponse<Notification>> {
  const response = await instance.get<PaginatedResponse<Notification>>(
    `/api/${orgSlug}/notifications/`,
    { params },
  );
  return response.data;
}

export function useFetchNotifications(
  params?: FetchNotificationsParams,
  options?: { enabled?: boolean },
) {
  const orgSlug = useOrganizationStore((s) => s.orgSlug);
  return useQuery({
    queryKey: [...notificationKeys.list(params), orgSlug],
    queryFn: orgSlug ? () => fetchNotifications(orgSlug, params) : skipToken,
    enabled: options?.enabled ?? true,
    placeholderData: (previousData) => previousData,
    meta: { errorMessage: "Couldn't load notifications. Please refresh." },
  });
}

export default useFetchNotifications;
